import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


class ModalBehaviorSubject {
    toggle: BehaviorSubject<boolean>;
    confirm: BehaviorSubject<SubmitEvent>;
    inputData: any
}

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    private _modals: {
        [key: string]: ModalBehaviorSubject
    } = {};

    constructor() { }

    registerModalBehavior(selector: string): BehaviorSubject<boolean> {
        this._modals[selector] = {
            toggle: new BehaviorSubject(false),
            confirm: new BehaviorSubject(null),
            inputData: null
        } as ModalBehaviorSubject;

        return this._modals[selector].toggle;
    }

    unregisterModal(selector: string) {
        delete this._modals[selector];
    }

    openModal(selector: string, inputData?: any) {
        if (inputData != null) {
            this._modals[selector].inputData = inputData;
        }

        this._modals[selector].toggle.next(true);
        return this._modals[selector];
    }

    closeModal(selector: string) {
        this.resetConfirm(selector)
        this._modals[selector].toggle.next(false);
    }

    confirm(selector: string, submitEvent: SubmitEvent) {
        this._modals[selector].confirm.next(submitEvent);
    }

    getInputData(selector: string) {
        return this._modals[selector].inputData;
    }

    getModal(selector: string) {
        return this._modals[selector];
    }

    resetConfirm(selector: string) {
        this._modals[selector].confirm = new BehaviorSubject(null);
    }
}
